<template>
  <!--
    The outermost div is already flex + items-center + justify-center,
    which will center its child both horizontally and vertically.
  -->
  <div class="flex-grow bg-gray-100 flex items-center justify-center">
    <!-- 1) Not logged in: show big login button (keeps its own centering) -->
    <div
      v-if="!isAuthenticated"
      class="flex flex-col items-center justify-center w-full h-full"
    >
      <button
        class="
          bg-[#83bd48]       /* Sushi */
          text-white
          text-2xl
          font-semibold
          px-8 py-4
          rounded-lg
          shadow-lg
          hover:bg-[#0dabcb] /* Cerulean on hover */
          transition
          duration-200
        "
        @click="login"
      >
        Log in to Pronto
      </button>
    </div>

    <!-- 2) Logged in: center the tile grid -->
    <div
      v-else
      class="
        flex 
        flex-col 
        items-center 
        justify-center 
        py-16 
        w-full 
        max-w-screen-lg 
      "
    >
      <!-- Heading -->
      <h1 class="text-4xl font-bold mb-10 text-center">
        Welcome to Pronto
      </h1>

      <!-- 
        We removed the “w-full” on this grid wrapper and replaced it with a max-width.
        Because its parent is flex + items-center + justify-center, the grid will sit in the middle.
      -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 lg:px-0">
        <AppTile
          v-for="tile in tiles"
          :key="tile.title"
          :title="tile.title"
          :to="tile.to"
          :icon="tile.icon"
          :disabled="!isAuthenticated || (isProductionEnv && tile.disableInProduction)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/pinia/authStore';
import AppTile from '@/ReusableComponents/AppTile.vue';

const authStore = useAuthStore();
const isAuthenticated = computed(() => authStore.isAuthenticated);

const login = () => {
  authStore.login();
};

const environment = process.env.VUE_APP_ENVIRONMENT || process.env.NODE_ENV || 'production';
const isProductionEnv = environment === 'production';

const tiles = [
  { title: 'DSA Report', to: '/dsa-report', icon: 'bar-chart', disableInProduction: false },
  { title: 'Project Management', to: '/project-management', icon: 'clipboard-list', disableInProduction: false },
  { title: 'My Dashboard', to: '/employee-dashboard/me', icon: 'layout-dashboard', disableInProduction: false },
  { title: 'Staff Insights', to: '/employee-insights', icon: 'users', disableInProduction: false },
  { title: 'Help', to: '/help', icon: 'question-mark-circle', disableInProduction: false },
];
</script>

<style scoped>
</style>
